import { useRequest } from "@1f/react-sdk"
import sharedDatasInstance from "../sharedDatas";
import { v4 as uuidv4 } from "uuid";

export const TsDigitalApi = () => {    
    const tsApiTenant = useRequest({ lazy: true });
    const tsApiUser = useRequest({ lazy: true });
    const tsApiSubscription = useRequest({ lazy: true });
    const tsApiSignatureConfig = useRequest({ lazy: true });

    const GetTenantFromDigital = async (authTenantId, accessToken,loggedUserId) => {
        try {
            let completeRequestUrl = "aml:registry-read-agyo:api://" + authTenantId + "?packageType=BASE&pagination.itemsPerPage=1&pagination.pageNumber=0"
            const tsTenantResponse = await tsApiTenant.fetch({
                url: completeRequestUrl,
                headers: {
                Authorization: "Bearer " + accessToken,
                "X-App-Name": "TS420",
                "X-App-Version": "1.0.0",
                "X-Request-ID": uuidv4(),
                "X-Correlation-ID": uuidv4(),
                "Content-Type": "application/json",
                "X-Item-ID": authTenantId,
                "X-User-ID": loggedUserId,
                },
            });

            const tenantItem = tsTenantResponse.data.item.base;                      
            if(tenantItem) return tenantItem;        
        } catch (error) {
            throw new Error("Errore durante il recupero del tenant da Digital: " + error.message);
        }
    }
    const GetUserInfoFromDigital = async (authTenantId,accessToken,loggedUserId) => {
        try {
            let completeRequestUrl = "aml:user-read-agyo:api://" + loggedUserId + "?profileType=FULL"
            const tsUserResponse = await tsApiUser.fetch({
                url : completeRequestUrl,
                headers: {
                    Authorization: "Bearer " + accessToken,
                    "X-App-Name": "TS420",
                    "X-App-Version": "1.0.0",
                    "X-Request-ID": uuidv4(),
                    "X-Correlation-ID": uuidv4(),
                    "Content-Type": "application/json",
                    "X-Item-ID": authTenantId,
                    "X-User-ID": loggedUserId,
                },
            });
            if(tsUserResponse)
                return tsUserResponse.data;
        } catch (error) {
            throw new Error("Errore durante il recupero dell'utente da Digital: " + error.message);
        }
    }

    const GetSignatureConfig = async (authTenantId,accessToken,loggedUserId) => {
        try {
            const signatureConfigResponse = await tsApiSignatureConfig.fetch({
                url: `aml:signature-config:api://config/${encodeURIComponent(authTenantId)}`,
                headers: {
                    Authorization: "Bearer " + accessToken,
                    "X-App-Name": "TS420",
                    "X-App-Version": "1.0.0",
                    "X-Request-ID": uuidv4(),
                    "X-Correlation-ID": uuidv4(),
                    "X-Item-ID": authTenantId,
                    "X-User-ID": loggedUserId,
                },
            });
            return signatureConfigResponse?.data;
        } catch (error) {
            throw new Error("Errore durante il recupero della configurazione Signature: " + error.message);
        }
    }

    const GetSubscriptionInfoFromDigital = async (authTenantId,accessToken,loggedUserId) => {
        try {
            const completeRequestUrl = `aml:services-read:subscriptions://items?itemIds=${authTenantId}`;
            const tsSubscriptionResponse = await tsApiSubscription.fetch({
                url: completeRequestUrl,
                headers: {
                    Authorization: "Bearer " + accessToken,
                    "X-App-Name": "TS420",
                    "X-App-Version": "1.0.0",
                    "X-Request-ID": uuidv4(),
                    "X-Correlation-ID": uuidv4(),
                },
            });
            return tsSubscriptionResponse?.data?.itemServices?.[authTenantId] ?? [];
        } catch (error) {
            throw new Error("Errore durante il recupero delle sottoscrizioni da Digital: " + error.message);
        }
    }

    return {
        GetTenantFromDigital,
        GetUserInfoFromDigital,
        GetSignatureConfig,
        GetSubscriptionInfoFromDigital
    }
}